'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import { useAuth } from '@/lib/context/AuthContext';
import { TopNav } from './TopNav';
import { MOBILE_NAV, isNavActive } from './shellNav';

export function DashboardLayout({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const pathname = usePathname();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      router.replace('/login');
    }
  }, [loading, user, router]);

  if (loading || !user) {
    return <div className="mx-app mx-app--top mx-theme" />;
  }

  return (
    <div className="mx-app mx-app--top mx-theme">
      <TopNav />
      <main className="mx-content">{children}</main>
      <nav className="mx-tabbar" aria-label="Navigasi mobile">
        {MOBILE_NAV.map(({ href, label, Icon }) => {
          const active = isNavActive(pathname, href);
          return (
            <Link
              key={href}
              href={href}
              className={`mx-tabbar__item${active ? ' mx-tabbar__item--active' : ''}`}
              aria-current={active ? 'page' : undefined}
            >
              <Icon size={20} color="currentColor" />
              {label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
